module.exports = __webpack_public_path__ + "img/prev-quiz-icon.5caabf6c.svg";